export default __webpack_public_path__ + "assets/images/9be5d59ab0e9451d74a92bcb7f24abd8.png";